import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  $('#print-page-btn').click(() => {
    window.print()
  })
})
